import { normalizeProductFormatCode, resolvePriceProductFormatCode } from './clientType';
import { isRepeatableProductFormat } from './varietyFormatIdentity';

const POS_FORMAT_FILTERS = [
  { value: 'pack', label: 'Pack' },
  { value: 'detalle', label: 'Detalle' },
];

const posPriceFormatOrder = (price, formatOptions) => {
  if (isRepeatableProductFormat(price, formatOptions)) return 0;
  const code = resolvePriceProductFormatCode(price);
  if (code === 'detalle') return 1;
  if (code === 'oferta') return 2;
  return 3;
};

export const comparePosPriceFormats = (left, right, formatOptions = []) => (
  posPriceFormatOrder(left, formatOptions) - posPriceFormatOrder(right, formatOptions)
);

export const resolvePosFormatFilter = (value, formatOptions = []) => {
  const code = normalizeProductFormatCode(value);
  if (code === 'detalle' || code === 'oferta') return 'detalle';
  return isRepeatableProductFormat(code, formatOptions) ? 'pack' : '';
};

export const buildPosFormatFilterOptions = (formatOptions = [], allowedFormatCodes = []) => {
  const availableGroups = new Set(formatOptions
    .filter((option) => !allowedFormatCodes.length || allowedFormatCodes.includes(option.value))
    .map((option) => resolvePosFormatFilter(option.value, formatOptions)));
  return POS_FORMAT_FILTERS.filter((option) => availableGroups.has(option.value));
};

export const matchesPosFormatFilter = (price, filter, formatOptions = []) => {
  const group = isRepeatableProductFormat(price, formatOptions)
    ? 'pack'
    : resolvePosFormatFilter(resolvePriceProductFormatCode(price), formatOptions);
  return Boolean(group) && (!filter || group === filter);
};
